export default {
  "logoLink": "https://www.atfx.com/uk/ur/",//修改该参数请在/static/lang.js也需修改
  "FCA_License_No": "FCA License No",//修改该参数请在/static/lang.js也需修改
  "headTtitle": "ایک لائیو فاریکس اور CFD ٹریڈنگ اکاؤنٹ کھولیں | ATFX یو-کے",//修改该参数请在/static/lang.js也需修改
  "topFixedBanner": "Spread bets and CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. The vast majority of retail client accounts lose money when trading CFDs. You should consider whether you can afford to take the high risk of losing your money.",//修改该参数请在/static/lang.js也需修改
  "topFixedBannerShort": "59.38% of retail investor accounts lose money when trading CFDs / Spread betting with this provider.",//修改该参数请在/static/lang.js也需修改
  "headDescription": "یو-کے FCA منضبط کردہ بروکر کے ساتھ ایک ATFX فاریکس اور CFD لائیو اکاؤنٹ کھولیں۔ کم اسپریڈ، لیوریج 1:200، MT4 پلیٹ فارم، 24/5 صارف معاونت۔ ابھی ایک اکاؤنٹ سائن اپ کریں!",
  "policyBarClose": 'The Firm has taken the decision to cease providing services to retail clients, with immediate effect. We are therefore unable to accept any applications.<br />Services to professional clients will not be impacted. For professional applications please contact<a href="mailto:cs.uk@atfx.com">cs.uk@atfx.com</a><br />',
  "policyBar":'We use cookies to ensure you get the best experience on our website. By continuing to browse you accept our use of cookies. <a title="[Read more]" href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Cookies%20Policy%20EN.pdf" target="_blanck">[Read more]</a>',
  "policyBarButton":'Accept',
  "header": {
    "registration": "اکاؤنٹ کھولنا",
    "personalDetails1": "ذاتی تفصیلات 1",
    "personalDetails2": "ذاتی تفصیلات 2",
    "financialDetails": "مالیاتی تفصیلات",
    "Experience": "تجربہ",
    "Knowledge": "علمی",
    "Acknowledgements": "تسلیمات",
    "previewPage":"پیش نظارہ",
    "liveTrading": "LIVE TRADING"
  },
  footer:{//修改该参数请在/static/lang.js也需修改
    "copyright":"© 2020 ATFX.COM. All rights reserved.",
    "terms1":"Privacy Polic",
    "terms2":"Cookies Policy",
    "terms3":"Terms and Conditions",
    "Legal":"Legal: AT Global Markets (UK) Limited is authorised and regulated by the Financial Conduct Authority (FCA) in the United Kingdom. FCA registration number (760555). Registered Office: 1st Floor, 32 Cornhill, London EC3V 3SG,United Kingdom. Company No. 09827091",
    "riskWaring":'HIGH RISK INVESTMENT WARNING: CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. <strong>59.38% of retail investor accounts lose money when trading CFDs with this provider. </strong>You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money. Please read the full <a title=" Risk Disclosure Policy" href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf" target="_blanck">Risk Disclosure Policy</a>.',
    "otherInfo":"The information on this site is not directed at residents of the United States, Belgium or any particular country outside the UK and is not intended for distribution to, or use by, any person in any country or jurisdiction where such distribution or use would be contrary to local law or regulation."
  },
  "headerMsg": {
    "personalDetails1": "ذاتی تفصیلات 1",
    "personalDetails2": "ذاتی تفصیلات 2",
    "financialDetails": "مالیاتی تفصیلات",
    "experience": "تجربہ",
    "knowledge": "علمی",
    "acknowledgements": "تسلیمات"
  },
  "changeLanguage": "زبان تبدیل کریں",
  "back": "واپس جائیں",
  "next": "اگلا",
  "finish": "ختم کریں",
  "personalDetails1": {
    "estimatedTime":"Estimated time to complete your registration is 5 minutes",
    "Gender": "صنف",
    "genderSelect": {
      "M": "جناب",
      "F": "ایم ایس",
      "O":"دیگر"
    },
    "OtherGender":"دوسری جنس",
    "Title": "عنوان",
    "titleSelect":{
      "Mr":"مسٹر",
      "Mrs":"مسز",
      "Ms":"محترمہ",
      "Miss":"مس",
      "Dr":"ڈاکٹر",
      "Other":"دیگر"
    },
    "OtherTitle":"دوسرے عنوان",
    "First_Name": "پہلا نام",
    "Surname": "عرفیت",
    "Email": "ای-میل",
    "Email_Confirm": "ای میل کی تصدیق",
    "Lang": "ای میل کی زبان",
    "emailLanguages": {
      "ENG": "انگریزی",
      "CHT": "روایتی چینی",
      "CHS": "چینی چینی",
      "ARA": "عربی",
      "ESP": "سپينش",
      "ITA": "اطالوی",
      "GER": "German",
      "PTG": "Portuguese"
    },
    "MT4_Currency":"ٹریڈنگ اکاؤنٹ کرنسی",
    "MT4CurrencySelect":{
      "USD":"(USD) ڈالر",
      "GBP":"(GBP) پونڈ",
      "EUR":"(EUR) یورو"
    },
    "Account_Type": "MT4 Account Type",
    "Account_TypeSelect": {
      "CFDs": "CFDs",
      "SpreadBetting": "بیٹنگ پھیلانا"
    },
    "Country": "قیام کا ملک",
    "countrySelect": {
      "USA": "United States of America",
      "HKG": "Hong Kong",
      "GBR":"برطانیہ",
      "CHN":"چین",
      "TWN":"تائیوان",
      "ARE":"متحدہ عرب امارات",
      "ALB":"البانیا",
      "AND":"انڈورا",
      "AIA":"انگویلا",
      "ATG":"اینٹیگوا اور باربوڈا",
      "ARG":"ارجنٹینا",
      "ARM":"آرمینیا",
      "ABW":"اروبا",
      "AUS":"آسٹریلیا",
      "AUT":"آسٹریا",
      "AZE":"آذربائیجان",
      "BHS":"بہامس",
      "BHR":"بحرین",
      "BGD":"بنگلہ دیش",
      "BRB":"بارباڈوس",
      "BLR":"بیلارس",
      "BEL":"بیلجیم",
      "BLZ":"بیلائز",
      "BEN":"بینن",
      "BMU":"برمودا",
      "BOL":"بولیویا",
      "BWA":"بوٹسوانا",
      "BVT":"جزیرہ بووٹ",
      "BRA":"برازیل",
      "BRN":"برونائی دارلسلام",
      "BGR":"بلغاریہ",
      "BFA":"برکینا فاسو",
      "BDI":"برونڈی",
      "KHM":"کمبوڈیا",
      "CMR":"کیمرون",
      "CPV":"کیپ ورڈے",
      "CYM":"کے مین جزائر",
      "CAF":"جمہوریہ وسطی افریقہ",
      "TCD":"چاڈ",
      "CHL":"چلی",
      "CCK":"کوکوس جزائر",
      "COL":"کولمبیا",
      "COM":"کوموروس",
      "COK":"جزائر کک",
      "CRI":"کوسٹا ریکا",
      "CIV":"آئیوری کوسٹ",
      "HRV":"کروشیا",
      "CUB":"کیوبا",
      "CYP":"قبرص",
      "CZE":"چیک",
      "DNK":"ڈنمارک",
      "DJI":"جبوتی",
      "DMA":"ڈومینیکا",
      "DOM":"جمہوریہ ڈومینیکن",
      "EGY":"مصر",
      "SLV":"ایل سلواڈور",
      "ERI":"اریٹیریا",
      "EST":"ایسٹونیا",
      "ETH":"ایتھوپیا",
      "FJI":"فجی",
      "FIN":"فن لینڈ",
      "PYF":"فرانسیسی پولینیشیا",
      "GAB":"گبون",
      "GEO":"جارجیا",
      "DEU":"جرمنی",
      "GHA":"گھانا",
      "GIB":"جبرالٹر",
      "GRC":"یونان",
      "GRL":"گرین لینڈ",
      "GRD":"گریناڈا",
      "GLP":"گواڈیلوپ",
      "GTM":"گواٹے مالا",
      "GIN":"گنی",
      "GNB":"گنی-بساؤ",
      "HTI":"ہیٹی",
      "HMD":"جزائر ہرڈ اور جزائر مکڈونلڈ",
      "HND":"ہونڈوراس",
      "HUN":"ہنگری",
      "ISL":"آئس لینڈ",
      "IND":"ہندوستان",
      "IDN":"انڈونیشیا",
      "IRL":"آئرلینڈ",
      "ISR":"اسرائیل",
      "ITA":"اٹلی",
      "JAM":"جمیکا",
      "JPN":"جاپان",
      "JOR":"اردن",
      "KAZ":"قزاقستان",
      "KEN":"کینیا",
      "KIR":"کرباتی",
      "KOR":"کوریا، جمہوریہ",
      "KWT":"کویت",
      "KGZ":"کرغستان",
      "LVA":"لٹویا",
      "LSO":"لیسوتھو",
      "LBR":"لائبیریا",
      "LBY":"لیبیا",
      "LIE":"لکٹنسٹائن",
      "LTU":"لتھوانیا",
      "LUX":"لیگزمبرگ",
      "MAC":"میکاؤ",
      "MDG":"مڈغاسکر",
      "MWI":"ملاوی",
      "MYS":"ملائیشیا",
      "MDV":"مالدیپ",
      "MLI":"مالی",
      "MLT":"مالٹا",
      "MHL":"جزائر مارشل",
      "MTQ":"مارٹنیک",
      "MUS":"ماریشس",
      "MYT":"میوٹی",
      "MEX":"میکسیکو",
      "MDA":"مالدووا",
      "MCO":"مناکو",
      "MNG":"منگولیا",
      "MNE":"مونٹینیگرو",
      "MSR":"مانٹسریٹ",
      "MAR":"مراکش",
      "MOZ":"موزمبیق",
      "NAM":"نمیبیا",
      "NRU":"ناؤرو",
      "NLD":"نیدر لینڈز",
      "NCL":"نیو کیلیڈونیا",
      "NZL":"نیوزی لینڈ",
      "NIC":"نکاراگوا",
      "NER":"نائیجر",
      "NGA":"نائیجیریا",
      "NIU":"نیو",
      "NFK":"جزیرہ نارفولک",
      "NOR":"ناروے",
      "OMN":"عمان",
      "PAK":"پاکستان",
      "PSE":"فلسطین",
      "PRY":"پیراگوئے",
      "PER":"پیرو",
      "PHL":"فلپائن",
      "PCN":"پٹکیرن",
      "POL":"پولینڈ",
      "PRT":"پرتگال",
      "QAT":"قطر",
      "ROU":"رومانیہ",
      "RUS":"روس",
      "RWA":"روانڈا",
      "SHN":"سینٹ ھیلینا",
      "KNA":"سینٹ کٹس اور نیوس",
      "LCA":"سینٹ لوسیا",
      "SPM":"سینٹ پیئر و میکوئیلون",
      "VCT":"سینٹ کیرن اور گریناڈائنز",
      "WSM":"ساموا",
      "SMR":"سان میرینو",
      "STP":"ساؤ ٹوم اور پرنسپے",
      "SAU":"سعودی عرب",
      "SEN":"سینیگال",
      "SRB":"سربیا",
      "SYC":"سیچیلز",
      "SLE":"سیرا لیون",
      "SGP":"سنگاپور",
      "SVK":"سلوواکیا",
      "SVN":"سلووینیا",
      "ZAF":"جنوبی افریقہ",
      "ESP":"اسپین",
      "SUR":"سورینام",
      "SJM":"سوالبارڈ اور جان ماین",
      "SWZ":"سوازی لینڈ",
      "SWE":"سویڈن",
      "CHE":"سوئٹزرلینڈ",
      "TJK":"تاجکستان",
      "TZA":"تنزانیہ",
      "THA":"تھائی لینڈ",
      "TLS":"ٹیمور لیسٹی",
      "TGO":"ٹوگو",
      "TON":"ٹونگا",
      "TTO":"ترینی داد اینڈ ٹوباگو",
      "TUN":"تیونس",
      "TUR":"ترکی",
      "TKM":"ترکمانستان",
      "TCA":"جزائر ترکیہ اور کیکس",
      "TUV":"ٹوالو",
      "UKR":"یوکرین",
      "URY":"یوراگوئے",
      "UZB":"ازبکستان",
      "VUT":"وینٹاؤ",
      "VAT":"ویٹی کن",
      "VEN":"وینزویلا",
      "VNM":"ویت نام",
      "WLF":"والس اور فتونہ",
      "ESH":"مغربی صحارا",
      "ZMB":"زیمبیا",
      "DZA": "Algeria",
      "AGO": "Angola",
      "BIH": "Bosnia-Herzegovina",
      "GMB": "Gambia",
      "GUY": "Guyana",
      "IRQ": "Iraq",
      "RKS": "Kosovo",
      "LBN": "Lebanon",
      "MKD": "Macedonia",
      "NPL": "Nepal",
      "PAN": "Panama",
      "PNG": "Papua New Guinea",
      "LKA": "Sri Lanka"
    }
  },
  "personalDetails2": {
    "Addr": "پتہ سطر 1",
    "Addr2": "پتہ سطر 2",
    "City": "قصبہ / شہر",
    "Postcode": "پوسٹ کوڈ",
    "Building_Name": "عمارت نمبر / نام",
    "Street": "سٹریٹ",
    "Province": "صوبہ",
    "birthDate": "تاریخ پیدائش:",
    "birthYear": "سال",
    "birthMonth": "مہینہ",
    "birthSecond": "دن",
    "Nationality": "قومیت",
    "isHavePass": "کیا آپ کے پاس ایک پاسپورٹ ہے",
    "PotSelect": {
      "havePot": "ہاں",
      "noPot": "نہيں"
    },
    "NAT_ID": "پاسپورٹ",
    "Phone": "فون",
    "countryPlace": "ٹیکس کی رہائش کا ملک",
    "TIN": "TIN (ٹیکس دہندہ شناختی نمبر)",
    "Doc_Type": "شناخت کی قسم",
    "idTypeSelect": {
      "POT": "پاسپورٹ",
      "IDC": "شناختی کارڈ",
      "DRI": "ڈرائیور لائسنس"
    },
    "Doc_No": "شناخت نمبر",
    "bankCardType": "بینک کارڈ قسم",
    "bankCardTypeSelect": {
      "DR": "ڈیبٹ کارڈ",
      "CR": "کریڈٹ کارڈ"
    },
    "Addr_Country":"ایڈریس ملک",
    "Bank_Card_No": "بینک نمبر",
    "bankCardNoConfirm": "بینک نمبر کی توثیق",
    "Bank": "بینک",
    "bankSelect": {
      "ICBK": "چین کا صنعتی اور تجارتی بینک",
      "ABOC": "ایگریکلچر بینک آف چائنا",
      "PCBC": "چائنا کنسٹرکشن بینک کارپوریشن",
      "BKCH": "بینک آف چائنا لمیٹڈ",
      "CMBC": "چائنا مرچنٹس بینک",
      "COMM": "بینک آف کمیونیکیشنز",
      "MSBC": "چائنا منشینگ بینکنگ کارپوریشن، لمیٹڈ",
      "EVER": "چائنہ ایوربرائٹ بینک",
      "SPDB": "شنگھائی پوڈونگ ڈویلپمنٹ بینک",
      "FJIB": "انڈسٹریل بینک",
      "CIBK": "CITIC بینک کارپوریشن لمیٹڈ",
      "PSBC": "پوسٹل سیونگز بینک آف چائنا",
      "SZCB": "شینزین ڈویلپمنٹ بینک، کارپوریشن لمیٹڈ",
      "GDBK": "چائنہ گوانگفا بینک",
      "BOSH": "بینک آف شنگھائی",
      "BJCN": "بینک آف بیجنگ",
      "HXBK": "ہوا زیا بینک",
      "other": "دیگر"
    },
    "OtherBank": "دیگر بینک",
    "Beneficiary_Name": "فائدہ لینے والے کا نام",
    "SWIFT_Code": "بینک سوفٹ کوڈ",
    "Branch_Name": "برانچ کا نام",
    "Bank_Addr": "برانچ کا پتہ",
    "Branch_Province": "برانچ کا صوبہ",
    "Branch_City": "برانچ کا شہر",
    "bankCardImg": "بینک کارڈ شبیہ",
    "IBAN_Code":"IBAN کوڈنگ",
    "docFrontImgword": "آئی ڈی شبیہ (سامنے سے):",
    "docBackImgword": "آئی ڈی شبیہ (عقب سے):",
    "addressUpload": "پتہ کا ثبوت",
    "addressUpload2": "پتہ کا ثبوت 2",
    "addressUploadTxt1": "دستیاب ثبوت: بجلی / گیس بل کی فہرست / بینک کی اسٹیٹمنٹس / رہائش کا پرمٹ / لائسنس / آئی ڈی / hukou (اگر درکواست دہندہ گھرانہ کا سرابراہ نہیں ہے، اس کے ساتھ ایک صفحہ کے جمع کرانے کی تصویر میں انضمام کرنے کی ضرورت کے ساتھ)؛",
    "addressUploadTxt2": "پتہ کا ثبوت شناختی سرٹیفکیٹ کے طور پر ایک جیسا نہیں ہونا چاہئے۔",
    "docImgword1": "دستاویز منسلکہ 1",
    "docImgword2": "دستاویز منسلکہ 2",
    "docImgword3": "دستاویز منسلکہ 3",
    "docImgword4": "دستاویز منسلکہ 4",
    "docImgword5": "دستاویز منسلکہ 5",
    "fileUpload":{
      "imgtUpload": "اپ لوڈ کریں",
      "uploadFileArr": [{
        "labelTxt": "شناختی تصویر 1",
        "ValidateNull": "براہ مہربانی منتخب کریں",
        "sizeLimit": "آئی ڈی Image1 5 ایم بی حد سے تجاوز نہیں کر سکتے!"
      }, {
        "labelTxt": "شناختی تصویر 2",
        "ValidateNull": "براہ مہربانی منتخب کریں",
        "sizeLimit": "آئی ڈی Image2 5 ایم بی حد سے تجاوز نہیں کر سکتے!"
      }, {
        "labelTxt": "پتہ کا ثبوت",
        "ValidateNull": "براہ مہربانی منتخب کریں",
        "sizeLimit": "پتہ کا ثبوت آئی ڈی تصویر 5MB سے متجاوز نہیں ہو سکتی ہے۔"
      },{
        "labelTxt": "پتہ کا ثبوت 2",
        "ValidateNull": "براہ مہربانی منتخب کریں",
        "sizeLimit": "پتہ کا ثبوت آئی ڈی تصویر 5MB سے متجاوز نہیں ہو سکتی ہے۔"
      },{
        "labelTxt": "دیگر فائلیں",
        "ValidateNull": "براہ مہربانی منتخب کریں",
        "sizeLimit": "دوسری فائلیں 5MB سے زیادہ نہیں ہوسکتی ہیں!"
      }],
      "addressUploadHtml": {
        "sizeLimit":"The file size cannot exceed 5MB",
        "upload_your_documents":"Upload Your Identity Documents",
        "documents_not_ready":"DOCUMENTS NOT READY?",
        "noe": "*Applicants must provide ID image and proof of address to verify their identity. We do not accept: mobile phone bills, credit card bills, or any mobile services bills; insurance receipts; invoice for purchased good/services.",
        "noe2":"You can still complete your application if you don't have the required documents right now. <br/><b>However, you will not be able to trade until we receive the required documents.<b/>",
        "header1": "Proof of Identity (Minimum requirement: $Logic)",
        "list1": "We require colour copies of the original government issued ID/passport document. For ID we require front and back sides of card.",
        "header2": "Proof of Address (Any $Logic of the following options)",
        "list2": "<ol class='list-style-position:inside'><li>Utility bill (water/electricity/gas) – issued in the past 3 months,</li><li>Bank Statement issued in the past 3 months,</li><li>We can accept residence books/property books including Chinese Hukou – but are subject to review.</li><li>A current rental agreement, and a supporting utility bill (gas/water/electricity), paid in previous 3 months, has to be provided.</li><li>A recent tax bill, if only issued in the past 6 months.</li><li>A landline Phone bill, issued in the past 3 month.</li></ol>",
        "strongTxt":"<strong>As part of our regulatory requirements, we may require additional documents in regards to your application.</strong>"
      }
    }
  },
  "financialDetails": {
    "Emp_Status": "ملازمت کی کیفیت",
    "employmentStatusSelect": {
      "b": "ملازمت میں",
      "a": "خود سے برسر روزگار",
      "c": "طالب علم",
      "e": "ریٹائر شدہ",
      "d": "بے روزگار"
    },
    "Freelance_OwnACompany": "فری لانس / ایک کمپنی کے مالک بنیں",
    "Freelance_OwnACompany_select": {
      "0":"فری لانس",
      "1":"ایک کمپنی کے مالک بنیں"
    },
    "Position": "پوزیشن",
    "FD_Position_select": {
      "0":"سی گریڈ منیجر جیسے، CEO، CFO، CIO",
      "1":"سینیئر مینیجر",
      "2":"جنرل / مڈل مینیجر",
      "3":"سپروائزر",
      "4":"کلرک",
      "5":"اسٹاف",
      "6":"جونیئر",
      "7":"دیگر (براہ مہربانی واضح کریں)"
    },
    "Employer": "کاروبار کا نام",
    "Biz_Nature": "کاروبار کی نوعیت",
    "financialRegulator": "آپ کے مالیاتی پورٹ فولیو کی قدر",
    "financialRegulatorSelect": {
      "Y": "جی ہاں",
      "N": "نہیں"
    },
    "Industry_Sector": "صنعت / شعبہ",
    "Industry_Sector_select": {
      "0":"اکاؤنٹنگ",
      "1":"ایڈورٹائزنگ/میڈیا",
      "2":"کمپیوٹر/انٹرنیٹ/کمیونیکیشن/الیکٹرانکس",
      "3":"تعلیم/تربیت",
      "4":"انرجی / خام مال",
      "5":"مالیاتی خدمات (فنانس/بینکنگ/انشورنس)",
      "6":"حکومت/غیر منافع بخش",
      "7":"ہیومن ریسورسز",
      "8":"قانونی",
      "9 ":"مارکیٹنگ",
      "10":"لاجسٹکس/نقل و حمل",
      "11":"دوا ساز/طبی",
      "12":"پیشہ ورانہ خدمات",
      "13":"ریئل اسٹیٹ / تعمیر",
      "14":"خدمت صنعت",
      "15":"ٹریڈ / صارف / مینوفیکچرنگ / آپریشنز",
      "16":"دیگر (براہ مہربانی واضح کریں)"
    },
    "Annual_Income": "Annual Income",
    "Annual_Income_word":"This includes all earned income including wages, pensions, interest, dividends, rental income etc.",
    "Total_Saving_Investments": "Total Saving & Investments",
    "Total_Saving_word": "This includes all bank or brokerage accounts, certificates, bonds, money market investments etc.",
    "Total_Saving_Investments_select": {
      "0": "US$500,000 سے زائد",
      "1": "US$200,000-US$499,999",
      "2": "US$100,000-US$199,999",
      "3": "US$50,000-US$99,999",
      "4": "US$25,000-US$49,999",
      "5": "US$10,000-US$24,999",
      "6": "US$2,000-US$9,999",
      "7": "US$2,000 سے کم"
    },
    "liquidNetWorth": "مائع خالص قدر (نجی رہائش گاہ چھوڑ کر)",
    "financialPortfolio": "آپ کے مالیاتی پورٹ فولیو کی قدر",
    "annualIncomeSelect": {
      "0": "US$200,000 سے زائد",
      "1": "US$100,000-US$199,999",
      "2": "US$50,000-US$99,999",
      "3": "US$25,000-US$49,999",
      "4": "US$10,000-US$24,999",
      "5": "US$10,000 سے کم"
    },
    "fundsSource": "ان رقوم کا ذریعہ",
    "fundsSourceSelect": {
      "0": "کوئی نہیں",
      "1": "خاندانی اور شریک حیات کی آمدنی",
      "2": "حکومتی فوائد",
      "3": "قرض/کریڈٹ",
      "4": "پینشن",
      "5": "پراپرٹی آمدنی",
      "6": "دیگر (براہ مہربانی واضح کریں)"
    },
    "Funds_Source": "آمدنی کے دیگر ذرائع",
    "Intend_Deposit": "آپ کتنا ڈیپازٹ کرانے کا ارادہ رکھتے ہیں؟",
    "intendDepositSelect": {
      "0": "US$100,000 سے زیادہ",
      "1": "US$80,000 – US$99,999",
      "2": "US$50,000 – US$79,999",
      "3": "US$25,000 – US$49,999",
      "4": "US$10,000 – US$24,999",
      "5": "US$10,000 سے کم"
    },
    "Other_Industry_Sector": "دیگر صنعت / شعبہ",
    "Other_Position": "دیگر پوزیشن",
    "Other_Biz_Nature": "دیگر کاروبار کی نوعیت",
    "Other_Funds_Source": "آمدنی کے دیگر ذرائع"
  },
  "Experience": {
    "experienceLabel": "گزشتہ تین سالوں میں، آپ نے مندرجہ ذیل مالیاتی آلات میں کس حد تک ٹریڈنگ کی ہے جہاں آپ نے اپنے خود سے ٹریڈنگ کے فیصلے کیے ہیں؟",
    "Futures_Options": "فیوچرز / اختیارات",
    "Futures_Options_select": {
      "0": "40 سے زیادہ مواقعوں پر",
      "1": "15 سے 40 مواقعوں پر",
      "2": "1 سے 15 مواقعوں پر",
      "3": "کبھی نہیں"
    },
    "CFDs_Spread_Bets": "CFDs، فارئین ایکسچینج ڈیریویٹیوز یا اسپریڈ بیٹس",
    "CFDs_Spread_Bets_select": {
      "0": "40 سے زیادہ مواقعوں پر",
      "1": "15 سے 40 مواقعوں پر",
      "2": "1 سے 15 مواقعوں پر",
      "3": "کبھی نہیں"
    },
    "Derivative_Trade_over2": "گزشتہ بارہ مہینوں میں، کیا آپ نے اسپاٹ FX / CFD اختیارات / فیوچرز یا اسپریڈ بیٹس میں کم سے کم دو ٹریڈز فی کواٹر کی ہیں جہاں آپ نے خود سے ٹریڈنگ کا فیصلہ کیا ہو؟",
    "Derivative_Trade_over2_select": {
      "b": "ہاں",
      "a": "نہیں"
    },
    "Derivative_Trade_over40": "گزشتہ تین سالوں کے دوران، کیا آپ نے اسپاٹ FX / CFDs / اختیارات / فیوچرز یا اسپریڈ بیٹس میں ایک بارہ ماہ کی مدت میں چالیس ٹریڈز کی ہیں؟",
    "Derivative_Trade_over40_select": {
      "b": "ہاں",
      "a": "نہیں"
    }
  },
  "Knowledge": {
    "DT_Work_Experience": "کیا آپ نے کبھی کسی ایسی حیثیت میں کام کیا ہے جس کے لئے ڈیریویٹیوز ٹریڈنگ کے علم کی ضرورت ہے؟",
    "DT_Work_Experience_select": {
      "txt1": "ہاں",
      "txt2": "نہیں",
      "subTxt1": "میرے پاس کم سے کم 3 سال کا کام کا تجربہ ہے",
      "subTxt2": "میرے پاس 3 سال سے کم کا کام کا تجربہ ہے یا اپنی طرف سے سرمایہ کاری کرنے کا کم از کم ایک سال کا تجربہ ہے۔"
    },
    "DT_Qualification": "کیا آپ کی ایسی قابلیت ہے جس نے آپ کو ڈیریویٹیو ٹریڈنگ کے بارے میں سوجھ بوجھ دی ہے؟",
    "DT_Qualification_select": {
      "txt1": "ہاں",
      "txt2": "نہیں",
      "subTxt1": "میں ایک پیشہ ورانہ قابلیت یا جیسے CFA، MBA، BSC یا MA کی ڈگری رکھتا ہوں",
      "subTxt2": "میں فنانس، اکنامکس، اکاؤنٹنگ یا اسی طرح کے شعبے میں اہلیت یا ڈگری رکھتا ہوں"
    },
    "K_Sell_Position": "اگر آپ ایک CFD میں فروخت کی حیثیت رکھتے ہیں اور موجودہ قیمت آپ کی فروخت کی قیمت سے اوپر ہے، کیا آپ پیسہ کمائیں گے یا کھو دیں گے؟",
    "K_Sell_Position_b": "اگر آپ ایک CFD میں فروخت کی حیثیت رکھتے ہیں اور موجودہ قیمت آپ کی فروخت کی قیمت سے اوپر ہے، کیا آپ پیسہ کمائیں گے یا کھو دیں گے؟",
    "K_Sell_Position_select": {
      "0": "کھو دیں گے",
      "1": "بنائیں گے"
    },
    "Closing_Order": "ٹریڈنگ کے دوران نقصان کو محدود کرنے میں مدد کے لئے آپ کس قسم کا بند کرنے کا آرڈر منتخب کر سکتے ہیں؟",
    "Closing_Order_select": {
      "0": "نقصان روک",
      "1": "منافع لیں"
    },
    "K_Profit_Change": "100:1 کی ایک لیوریج کے ساتھ CFDs اور دیگر ڈیریویٹیوز ٹریڈ کرتے ہوئے، کیا بنیادی مالیاتی آلہ کی قدر میں ایک چھوٹی سی تبدیلی کا نتیجہ آپ کے منافع یا نقصان میں غیر موزوں طور پر بڑی نقل و حرکت کی صورت میں ہو سکتا ہے؟",
    "K_Profit_Change_b": "100:1 کی ایک لیوریج کے ساتھ CFDs اور دیگر ڈیریویٹیوز ٹریڈ کرتے ہوئے، کیا بنیادی مالیاتی آلہ کی قدر میں ایک چھوٹی سی تبدیلی کا نتیجہ آپ کے منافع یا نقصان میں غیر موزوں طور پر بڑی نقل و حرکت کی صورت میں ہو سکتا ہے؟",
    "K_Profit_Change_select": {
      "0": "ہاں",
      "1": "نہیں"
    },
    "K_Margin": "1 لاٹ (100,000 یورو/جاپانی ین) کے لئے مطلوبہ مارجن کیا ہو گا، اگر آپ کا مارجن 1% (لیوریج 1:20) ہے؟",
    "K_Margin_select": {
      "0": "USD 5,000",
      "1": "USD 50,000",
      "2": "USD 100,000"
    }
  },
  "Acknowledgements": {
    "A1": "translation2.html:588 میں تصدیق کرتا ہوں کہ آپ کو فراہم کردہ معلومات درست اور مکمل ہے اور اس معلومات میں کوئی تبدیلی واقع ہوتی ہے تو آپ کو مطلع کرنے کی ذمہ داری لیتا ہوں۔",
    "A2": "میں نے AT گلوبل مارکیٹس کسٹمر معاہدے پڑھ، سمجھ اور اس کی پابندی کرنے سے اتفاق کر لیا ہے جو مجھے فراہم کیا گیا ہے۔",
    "A2_txt": "AT گلوبل مارکیٹس کسٹمر معاہدہ",
    "A2_link": "<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>AT گلوبل مارکیٹس کسٹمر کا معاہدہ</a>",
    "A3": "میں نے AT گلوبل مارکیٹس خطرے کے انکشاف کا بیان پڑھ، سمجھ اور اس سے اتفاق کر لیا ہے جو مجھے فراہم کیا گیا ہے۔",
    "A3_txt": "AT گلوبل مارکیٹ خطرے کے انکشاف کا بیان",
    "A3_link": "<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>AT گلوبل مارکیٹس خطرے کے انکشاف کا بیان</a>",
    "A4": "میں نے گلوبل مارکیٹس آرڈر پر عملدرآمد کی پالیسی اور تنازعہ کی پالیسی کو پڑھ، سمجھ اور اس سے اتفاق کر لیا ہے جو مجھے فراہم کیا گیا ہے۔",
    "A4_txt": "AT گلوبل مارکیٹس آرڈر عملدرآمد کی پالیسی اور تنازعات کی پالیسی",
    "A4_link": "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Order%20Execution%20Policy%20EN%20-%20V10.18.pdf' target='_blank'>AT گلوبل مارکیٹس آرڈر پر عمل درآمد کی پالیسی</a> اور <a href='https://www.atfx.com/uk/wp-content/uploads/conflict-of-interests-policy-uk-en.pdf' target='_blank'>تنازعات کی پالیسی</a>",
    "headaer": "اس درخواست کو مکمل کرنے سے آپ تصدیق کرتے ہیں کہ آپ سمجھتے ہیں کہ مارجن شدہ فاریکس اور CFD لیورجڈ مصنوعات ہیں اور میری لگائی گئی سرمایہ کے لئے ایک اعلٰی خطرہ پیدا کرتی ہیں۔ آپ مزید تصدیق کرتے ہیں کہ اپنے اکاؤنٹ کی نگرانی کرنا آپ کی ذمہ داری ہے، اور مصنوعات کی نوعیت کا مطلب ہے کہ آپ اپنی ابتدائی سرمایہ کاری کی نسبت زیادہ کھو سکتے ہیں۔",
    "age": "آپ تصدیق کرتے ہیں کہ آپ کی عمر 18 سال یا زیادہ ہے؛",
    "message": "اس درخواست میں فراہم کردہ معلومات سچ اور درست ہے، اگر اس معلومات میں کوئی تبدیلی واقع ہوتی ہے تو آپ ہمیں مطلع کرنے کی ذمہ داری لیتے ہیں؛",
    "receive": {
      "text": "آپ نے ہمارے ذیل کو پڑھ، سمجھ اور اتفاق کیا ہے",
      "list": ["<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf' target='_blank'>کاروبار کی شرائط اور خطرے کا انتباہ</a>",
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Order%20Execution%20Policy%20EN%20-%20V10.18.pdf' target='_blank'>آرڈر پر عمل درآمد کی پالیسی</a>",
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>رازداری کی پالیسی</a>",
        // "<a href='https://www.atfx.com/uk/wp-content/uploads/introducing-broker-disclosure-en.pdf' target='_blank'>Introducer Broker Disclosure</a>",
        "<a href='https://www.atfx.com/en/legal/?showEntity=uk' target='_blank'>Key Information Document</a>"
      ]
    },
    "A_select": {
      "text": "آپ نے ہمارے ذیل کو پڑھ، سمجھ اور اتفاق کیا ہے",
      "Y": "جی ہاں"
    },
    "checkboxTxt_A1": "میں نے تمام شرائط کو پڑھ، سمجھ اور ان سے اتفاق کر لیا ہے",
    "checkboxTxt_A2": "میں سمجھتا ہوں کہ CFD لیورجڈ مصنوعات ہیں اور ان کی کارکردگی غیر مستحکم ہو سکتی ہے",
    "checkboxTxt_A3": "میں سمجھتا ہوں کہ میرے اکاؤنٹ کی نگرانی اور منظم کرنا میری ذمہ داری ہے",
    "checkboxTxt_A4": "میں سمجھتا ہوں کہ لیوریجڈ مصنوعات کی ٹریڈنگ کرتے ہوئے میری ابتدائی سرمایہ کاری سے زیادہ کھو جانے کا امکان ہو سکتا ہے",
    "Marketing_Email_Preference": "میں ATFX سے معلومات حاصل کرنے پر رضامندی کرتا ہوں جو مارکیٹنگ مواد پر مشتمل ہوسکتا ہے",
    "Marketing_Email_Preference_select":{
      "Y": "ہاں",
      "N": "نہيں"
    },
    "Hear_ATFX":"اے ٹی ایف ایکس کے بارے میں آپ نے کیسے سنا؟",
    "OtherHearATFX":"دوسرے طریقوں",
    "hearATFXSelect":{
      "Recommendation":"سفارش",
      "SearchEngine":"سرچ انجن",
      "MediaAdvertising":"میڈیا ایڈورٹائزنگ",
      "Partnership":"شراکت داری",
      "Other":"دیگر"
    },
    "Parent_IB_Code": "حوالہ کار کوڈ",
    "Rec_Type": "حوالہ دینے والے کی قسم",
    "recTypeSelect": {
      "AA1": "AA1",
      "AA2": "AA2",
      "AA3": "AA3",
      "A01": "A01",
      "A02": "A02",
      "A03": "A03",
      "A00": "A00",
      "NAN": "کوئی حوالہ کار نہیں"
    },
    "recGroup": "حوالہ دینے والے کا گروپ",
    "recGroupSelect": {
      "A": "A",
      "AA": "AA"
    }
  },
  "customErrMsg": {
    "fieldIsRequired": {
      "Gender": "براہ مہربانی منتخب کریں",
      "OtherGender":"براہ کرم ایک اور صنف درج کریں",
      "Title": "براہ مہربانی منتخب کریں",
      "OtherTitle":"براہ کرم ایک اور عنوان درج کریں",
      "First_Name": "پہلا نام",
      "Surname": "عرفیت",
      "Email": "ای-میل",
      "Email_Confirm": "ای میل کی تصدیق کریں",
      "Lang": "براہ مہربانی منتخب کریں",
      "Country": "ملک/خطہ",
      "MT4_Currency":"براہ مہربانی منتخب کریں",
      "Account_Type":"براہ مہربانی منتخب کریں",
      "Addr": "پتہ",
      "Addr2": "پتہ سطر 2",
      "City": "شہر",
      "Postcode": "پوسٹ کوڈ",
      "Building_Name": "عمارت نمبر / نام",
      "Street": "سٹریٹ",
      "Province": "صوبہ",
      "Birth_Date_Year": "تاریخ پیدائش",
      "Birth_Date_Month": "تاریخ پیدائش",
      "Birth_Date_Day": "تاریخ پیدائش",
      "Nationality": "قومیت",
      "isHavePass": "براہ مہربانی منتخب کریں",
      "NAT_ID": "پاسپورٹ",
      "Phone": "فون",
      "Doc_Type": "براہ مہربانی منتخب کریں",
      "Doc_No": "شناخت نمبر",
      "Addr_Country": "براہ مہربانی منتخب کریں",
      "Bank_Card_No": "بینک نمبر",
      "Bank": "بینک",
      "OtherBank": "دیگر بینک",
      "Beneficiary_Name": "فائدہ لینے والے کا نام",
      "Branch_Name": "برانچ کا نام",
      "Bank_Addr": "برانچ کا پتہ",
      "Branch_Province": "برانچ کا صوبہ",
      "Branch_City": "برانچ کا شہر",
      "FD_Emp_Status": "براہ مہربانی منتخب کریں",
      "FD_Position": "پوزیشن",
      "FD_Employer": "کمپنی کا نام",
      "FD_Biz_Nature": "براہ مہربانی کاروباری خاصیت درج کریں",
      "FD_FCA_AUTH": "براہ کرم",
      "FD_Annual_Income": "براہ مہربانی منتخب کریں",
      "FD_Liquid_Net_Worth": "براہ مہربانی منتخب کریں",
      "FD_Portfolio_Value": "براہ مہربانی منتخب کریں",
      "FD_Funds_Source": "براہ مہربانی منتخب کریں",
      "FD_Funds_Other": "براہ مہربانی منتخب کریں",
      "E_Forex_Exp": "براہ مہربانی منتخب کریں",
      "E_Forex_Trade_No": "براہ مہربانی منتخب کریں",
      "E_Derivative_Exp": "براہ مہربانی منتخب کریں",
      "E_Derivative_Trade_No": "براہ مہربانی منتخب کریں",
      "E_Equity_Exp": "براہ مہربانی منتخب کریں",
      "E_Equity_Trade_No": "براہ مہربانی منتخب کریں",
      "K_A": "کیا آپ نے کبھی کسی ایسی حیثیت میں کام کیا ہے جس کے لئے ڈیریویٹیوز ٹریڈنگ کے علم کی ضرورت ہے؟",
      "K_A_Detail": "تفصیلات",
      "K_B": "کیا آپ نے ڈیریویٹیوز ٹریڈنگ سے متعلق کوئی تربیتی کورسز یا سیمینارز میں شرکت کی ہیں؟",
      "K_B_Detail": "تفصیلات",
      "K_C": "کیا آپ کی ایسی قابلیت ہے جس نے آپ کو ڈیریویٹیوز ٹریڈنگ کے بارے میں سوجھ بوجھ دی ہے؟",
      "K_C_Detail": "تفصیلات",
      "K_D": "کیا آپ لیورجڈ ٹریڈنگ کے خطرات اور میکینکس کو سمجھتے ہیں، اور بنیادی اثاثہ میں چھوٹی قیمتوں کی نقل و حرکت آپ کی سرمایہ کاری کی قیمت میں بڑے اتار چڑھاؤ کا سبب بن سکتی ہے؟",
      "K_E": "کیا آپ سمجھتے ہیں کہ آپ اپنی ابتدائی سرمایہ کاری سے زیادہ کھو سکتے ہیں؟",
      "K_F": "کیا آپ سمجھتے ہیں کہ ہر ٹرانزیکشن کے لئے ATFX آپ کا ہم منصب ہے اور آپ کو ہماری فرم کے ساتھ اپنی پوزیشن بند کرنی پڑے گی اور ہمارے کریڈٹ کے خطرے پر منکشف رہیں گے؟",
      "K_G": "کیا آپ سمجھتے ہیں کہ اگر مارکیٹ آپ کے خلاف چلتی ہے، تو آپ کو مختصر نوٹس پر اضافی مارجن جمع کرانا پڑے گا، اور مطلوبہ مارجن کی سطح کو برقرار رکھنے میں ناکامی، آپ کی پوزیشنوں کا خود کار طریقے سے بند کرنے کا سبب بن سکتی ہے؟",
      "K_H": "کیا آپ سمجھتے ہیں کہ روک تھام کے آرڈرز ہمیشہ آپ کے خطرے کو محدود نہیں کر سکتے ہیں اور ایک تیز رفتار حرکت کرتی مارکیٹ میں، آپ کو اپنے اسٹاپ کی قیمت سے مبرا سلیپیج کا تجربہ ہو سکتا ہے؟",
      "A1": "translation2.html:588 میں تصدیق کرتا ہوں کہ آپ کو فراہم کردہ معلومات درست اور مکمل ہے اور اس معلومات میں کوئی تبدیلی واقع ہوتی ہے تو آپ کو مطلع کرنے کی ذمہ داری لیتا ہوں۔",
      "A2": "میں نے AT گلوبل مارکیٹس کسٹمر معاہدے پڑھ، سمجھ اور اس کی پابندی کرنے سے اتفاق کر لیا ہے جو مجھے فراہم کیا گیا ہے۔",
      "A3": "میں نے AT گلوبل مارکیٹس خطرے کے انکشاف کا بیان پڑھ، سمجھ اور اس سے اتفاق کر لیا ہے جو مجھے فراہم کیا گیا ہے۔",
      "A4": "میں نے گلوبل مارکیٹس آرڈر پر عملدرآمد کی پالیسی اور تنازعہ کی پالیسی کو پڑھ، سمجھ اور اس سے اتفاق کر لیا ہے جو مجھے فراہم کیا گیا ہے۔",
      "checkList":"براہ مہربانی منتخب کریں",
      "Emp_Status": "براہ مہربانی منتخب کریں",
      "Freelance_OwnACompany": "براہ مہربانی منتخب کریں",
      "Industry_Sector": "براہ مہربانی منتخب کریں",
      "Position": "براہ مہربانی منتخب کریں",
      "Employer": "کمپنی کا نام",
      "Biz_Nature": "براہ مہربانی کاروباری خاصیت درج کریں",
      "Annual_Income": "براہ مہربانی منتخب کریں",
      "Total_Saving_Investments": "براہ مہربانی منتخب کریں",
      "Funds_Source": "براہ مہربانی منتخب کریں",
      "Intend_Deposit": "براہ مہربانی منتخب کریں",
      "Other_Industry_Sector": "دوسری صنعت / سیکٹر",
      "Other_Position": "دوسری پوزیشن",
      "Other_Biz_Nature": "دیگر کاروبار کی نوعیت",
      "Other_Funds_Source": "دیگر آمدنی کا ذریعہ",
      "Futures_Options": "براہ مہربانی منتخب کریں",
      "CFDs_Spread_Bets": "براہ مہربانی منتخب کریں",
      "Derivative_Trade_over2": "براہ مہربانی منتخب کریں",
      "Derivative_Trade_over40": "براہ مہربانی منتخب کریں",
      "DT_Work_Experience": "براہ مہربانی منتخب کریں",
      "DT_Qualification": "براہ مہربانی منتخب کریں",
      "K_Sell_Position": "براہ مہربانی منتخب کریں",
      "Closing_Order": "براہ مہربانی منتخب کریں",
      "K_Profit_Change": "براہ مہربانی منتخب کریں",
      "K_Margin": "براہ مہربانی منتخب کریں",
      "IBAN_Code":"برائے مہربانی آئی بی اے کوڈ درج کریں",
      "Hear_ATFX":"براہ مہربانی منتخب کریں",
      "OtherHearATFX":"براہ کرم درج کریں",
      "Rec_Type":"براہ مہربانی منتخب کریں",
      "Parent_IB_Code":"حوالہ کار کوڈ"
    }
  },
  "errors": {
    "fieldIsRequired": "ای میل پتہ",
    "invalidFormat": "غلط وضع!",
    "numberTooSmall": "نمبر بہت چھوٹا ہے! کم از کم: {0}",
    "numberTooBig": "نمبر بہت بڑا ہے! زیادہ سے زیادہ: {0}",
    "invalidNumber": "غلط نمبر",
    "textTooSmall": "متن کی طوالت بہت چھوٹی ہے! موجودہ: {0}، کم از کم: {1}",
    "textTooBig": "متن کی طوالت بہت بڑی ہے! موجودہ: {0}، زیادہ سے زیادہ: {1}",
    "thisNotText": "یہ ایک متن نہیں ہے!",
    "thisNotArray": "یہ ایک صف نہیں ہے!",
    "selectMinItems": "کم از کم {0} اشیاء منتخب کریں!",
    "selectMaxItems": "زیادہ سے زیادہ {0} اشیاء منتخب کریں!",
    "invalidDate": "غلط تاریخ!",
    "dateIsEarly": "تاریخ بہت جلدی کی ہے! موجودہ: {0}، کم از کم: {1}",
    "dateIsLate": "تاریخ بہت دیر کی ہے! موجودہ: {0}، زیادہ سے زیادہ: {1}",
    "invalidEmail": "ای میل پتہ دستیاب نہیں ہے!",
    "invalidURL": "غیر مجاز URL!",
    "invalidCard": "غلط کارڈ فارمیٹ!",
    "invalidCardNumber": "غلط کارڈ نمبر!",
    "invalidTextContainNumber": "غلط متن! اعداد یا خصوصی حروف پر مشتمل نہیں ہو سکتا ہے",
    "invalidTextContainSpec": "غلط متن! خصوصی حروف پر مشتمل نہیں ہو سکتا ہے",
    "incorrectComfirm": "دو ان پٹ غہرہم آہنگ ہے",
    "invalidBirthDate": "عمر 18-69 کی درخواست قبول کر رہا ہے",
    "invalidParentClnID": "براہ مہربانی 12 ہندسوں سے کم کا نمبر درج کریں!",
    "docImgFrontSizeLimit": "آئی ڈی تصویر (سامنے) 2MB سے متجاوز نہیں ہو سکتی",
    "docImgBackSizeLimit": "آئی ڈی تصویر (عقب) 2MB سے متجاوز نہیں ہو سکتی！",
    "imgSizeLimit": "پتہ کا ثبوت آئی ڈی تصویر 2MB سے متجاوز نہیں ہو سکتی ہے۔",
    "bankCardNoTopTwo": "بینک کارڈ کے پہلے دو ہندسے لائن سے باہر ہیں",
    "bankCardNoLnegth": "براہ مہربانی 16 -19 کا نمبر درج کریں",
    "dayErrors1": "یہ سال ایک لیپ کا سال ہے، اور کوئی دن نہیں ہے",
    "dayErrors2": "سال کے لئے اس کا سال، دن موجود نہیں ہے",
    "dayErrors3": "وہ دن اس مہیںہ میں موجود نہیں ہے",
    "emailError": "ای میل پتہ دستیاب نہیں ہے",
    "DocTypeNoError": "آئی ڈی نمبر غیرقانونی ہے",
    "DocFrontImg": "براہ مہربانی آئی کی تصویر (سامنے کی جانب) اپ لوڈ کریں",
    "DocBackImg": "براہ مہربانی آئی کی تصویر (عقبی جانب) اپ لوڈ کریں",
    "ProofofAddress": "براہ مہربانی پتہ کا ثوبت اپ لوڈ کریں",
    "Doc_No": "شناخت نمبر",
    "Phone": "فون",
    "Bank_Card_No": "بینک نمبر",
    "Birth_Date_Second": "تاریخ پیدائش",
    "phoneError": "غلط فون فارمیٹ",
    "bankNumError": "بینک نمبر فارمیٹ غلط ہے",
    "numType": "نمبر داخل کریں",
    "bankCodeError":"IBAN انکوڈنگ فارمیٹ غلط ہے"
  },
  "messages": {
    "fieldsWillBeReset": "تمام ان پٹ کو پھر سیٹ کیا جائے گا، براہ مہربانی تصدیق کریں",
    "completeTip1": "براہ مہربانی اپنی ای میل کی پڑتال کریں۔ آپ کا شکریہ۔",
    "completeTip2": "مکمل کیا! آپ کا شکریہ۔",
    "noCompleteTip": "معذرت، آپ کی ان پٹ معلومات غلط ہے اور مندرجہ بالا کارروائی ناکام ہو گئی ہے",
    "emailAndDocInvalid": "ای میل کو استعمال کیا جا چکا ہے",
    "phoneAndDocInvalid": "اکاؤنٹ نمبر کو استعمال کیا جا چکا ہے",
    "IBCodeInvalid": "حوالہ کار کوڈغلط ہے",
    "invalidBankCardNo": "بینک کارڈ کا نمبر غلط ہے۔ اسے جمع کرانے سے پہلے اس کی جانچ کریں",
    "beneficiaryName": "فائدہ لینے والے کا نام",
    "employerName": "آجر کا نام",
    "errors": "نیٹ ورک نقص",
    "unSelect":"براہ مہربانی منتخب کریں",
    "selectEmpStatusTip":"آپ طالب علموں اور بے روزگار ایک رفاحی اداروں کے اشتراک کی مصنوعات کے لئے CFD مصنوعات کو ریٹائر کرنے کا انتخاب کرتے ہیں اپنے اہم مفادات کی حفاظت کے لیے ہم چاہے آپ ہماری مصنوعات اور خدمات کے لئے موزوں ہیں کا جائزہ لینے کے لئے اپنے دیگر مواد کی بنیاد پر ہو گا"
  },
  "ModalMsg": {
    "showModal": {
      "content": "Based on the information you provided on your AT Global Markets Limited (UK) Limited client account application, it is necessary for us to inform you that trading in CFDs and leveraged forex may not be appropriate for you. Leveraged trading carries a high degree of risk to your capital. The Company provides an execution-‐‐only service to its clients and you will need to rely upon your own skill and judgement when trading these markets. <br/><br/><b>Please note: AT Global Markets (UK) Limited oﬀers demo accounts where you can practice trading against realistic market prices and the Company would encourage you to try this before trading with real money.</b><br/><br/>If you still wish to open a client account with AT Global Markets (UK) Limited, please conﬁrm this by accepting the statement below.",
      "checkboxTxt":"I understand that trading in CFDs and leveraged forex trading carries a high degree of risk to my capital. I am able to assess the risks involved and wish to continue with my application to open an account.",
      "errorsTxt": "منتخب کریں",
      "btn": "تصدیق کریں"
    },
    "showAlert": {
      "title": "ٹوٹکا:",
      "submitBtnTxt": "تصدیق کریں",
      "cancleBtnTxt": "منسوخ کریں",
      "confirmBtnTxt": "تصدیق کریں"
    }
  },
  "ratesModalMsg": {
    "p3_1": "WARNING - MARGIN RATE CHANGES FOR ALL RETAIL TRADERS",
    "p3_2": "Dear Applicant,",
    "p3_2_1": "",
    "p3_3": "Please note, due to the European Securities and Markets Authority (ESMA) changes for Retail Traders, all new ATFX clients from the 2nd July will be using the new Margin Rates.",
    "p3_4": "The changes include a cap on the amount of leverage that can be offered to retail traders.",
    "p4_1": "Major FX: Currency pairs containing any two of the following: USD, EUR, JPY, GBP, CAD, CHF - 3.33% (Leverage 30:1)",
    "p4_2": "Minor FX:  All other currency pairs - 5% (Leverage 20:1)",
    "p4_3": "Major indices: UK100, FRA40, ESP35, US30, SPX500, NAS100, JP225, AUS200 5% (Leverage 20:1)",
    "p4_4": "Gold: 5% (Leverage 20:1)",
    "p4_5": "Commodities: 10% (Leverage 10:1)",
    "p5_1": "Negative balance protection",
    "p5_2": "ESMA has introduced a new rule to ensure that all Retail Traders can never lose more than the money available on their account. If your balance does go negative, then ATFX will be obligated to bring your balance back to zero – at no cost to you, the client.",
    "p5_3": "50% margin close-out rule.",
    "p5_4": "ATFX already offers the 50% Margin Close out rule to all clients.",
    "p5_5": "If you wish to finalise your application and open an ATFX Retail Account please tick the below.",
    "p5_6": "I acknowledge and agree to the new terms for Retail Clients",
    "p6_2": "Please Agree ",
    "btnText": "SUBMIT"
  }
}



// WEBPACK FOOTER //
// ./src/lang/ur.js